import Flickity from './Flickity';
import 'flickity-fade';

const defaults = {
  fade: true,
  autoPlay: 4000,
  wrapAround: false,
  arrowShape: 'M58.7 20.6c.4-.4.8-.6 1.3-.6s1 .2 1.3.6c.4.4.6.9.6 1.4 0 .5-.2 1.1-.6 1.5L36.6 50.1l24.7 26.5c.7.8.7 2.1-.1 2.9-.7.7-1.9.7-2.6 0l-26.1-28c-.4-.4-.6-.9-.6-1.4 0-.5.2-1.1.6-1.4l26.2-28.1z',
};

export default class Gallery {
  constructor(element, options) {
    this.element = element;
    this.settings = { ...defaults, ...options };

    // Exit if we don't have more than one slide.
    if (!this.shouldBuildSlider) return this.ready();

    // Build Slider
    this.slider = this.buildSlider();

    // Add play/pause controls
    this.addControls();

    // Set initial state of the gallery
    this.setPlayState();

    // Add listeners
    this.listen();

    // Ready component
    this.ready();
  }

  ready() {
    // Append ready state.
    this.element.classList.add('ready');
  }

  buildSlider() {
    return new Flickity(this.element, this.settings);
  }

  onReady() {
    this.setPlayState();
  }

  onChange() {
    if (this.slider.player.state === 'stopped') {
      this.setPauseState();
    }
  }

  listen() {
    // Keep track of current state of gallery
    this.slider.on('change', this.onChange.bind(this));
  }

  addControls() {
    const item = document.createElement('li');
    this.playPauseButton = document.createElement('button');
    this.playPauseButton.className = 'button--play-pause';
    this.playPauseButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><polygon class="play" points="0 0 0 13 13 6.36 0 0"/><g class="pause"><path d="M11.15,0H8.85A.88.88,0,0,0,8,.91V12.13a.86.86,0,0,0,.85.87h2.31a.86.86,0,0,0,.84-.88V.91A.88.88,0,0,0,11.15,0Z"/><path d="M4.15,0H1.85A.88.88,0,0,0,1,.91V12.13a.86.86,0,0,0,.85.87H4.16A.86.86,0,0,0,5,12.12V.91A.88.88,0,0,0,4.15,0Z"/></g></svg>';
    this.playPauseButton.addEventListener('click', this.playPauseHandler.bind(this));
    item.appendChild(this.playPauseButton);
    this.sliderDots.appendChild(item);
  }

  playPauseHandler() {
    if (this.slider.player.state === 'stopped') {
      this.slider.playPlayer();
      this.setPlayState();
    } else {
      this.slider.stopPlayer();
      this.setPauseState();
    }
  }

  setPlayState() {
    this.playPauseButton.setAttribute('aria-label', 'Stop the slider\'s autoscroll');
    this.element.classList.add('playing');
  }

  setPauseState() {
    this.playPauseButton.setAttribute('aria-label', 'Start the slider\'s autoscroll');
    this.element.classList.remove('playing');
  }

  get shouldBuildSlider() {
    return this.slides.length > 1;
  }

  get sliderDots() {
    return this.element.querySelector('.flickity-page-dots');
  }

  get slides() {
    return this.element.children;
  }
}
